import { lazy } from 'react';

const Login        = lazy(() => import('./pages/Login/Login'));
const HomePage     = lazy(() => import('./pages/HomePage'));
const SecuredPage  = lazy(() => import('./pages/Securedpage'));
const ClientsPage  = lazy(() => import('./pages/Cliente'));
const Dispositivos = lazy(() => import('./pages/Dispositivos/Dispositivos'));
const DispositivosClientView = lazy(() => import('./pages/Dispositivos/DispositivosClientView'));
const SensoresEModelos = lazy(() => import('./pages/SensorEModelos/SensorModelPage'));
const Protocolos   = lazy(() => import('./pages/Protocols/Protocols'));
const Definicoes   = lazy(() => import('./pages/Definicoes/Definicoes'));
const Microbio     = lazy(() => import('./pages/Protocols/MicrobiologicalAnalysisPage'));
const UsuarioPage  = lazy(() => import('./pages/Usuarios/UsuarioPage'));
const PageExternal = lazy(() => import('./pages/PageExternal'));
const LicenciamentoAdminPage  = lazy(() => import('./pages/Licenciamento/LicenciamentoAdminPage'));
const LicenciamentoGestorPage = lazy(() => import('./pages/Licenciamento/LicenciamentoGestorPage'));
const Recursos     = lazy(() => import('./pages/Licenciamento/Recursos'));
const CertificadosPage = lazy(() => import('./pages/Certificados/CertificadosPage'));
const SensorCorPage = lazy(() => import('./pages/SensorCor/SensorCorPage'));
const NotFound     = lazy(() => import('./pages/NotFound'));
const FirmwarePage = lazy(() => import('./pages/Firmware/FirmwarePage'));
const FrotaPage    = lazy(() => import('./pages/Frota/FrotaPage'));
const TorrePage    = lazy(() => import('./pages/Frota/TorrePage'));
const AlertasPage  = lazy(() => import('./pages/Frota/AlertasPage'));

export const routes = [
    { path: '/',               element: Login,         private: false },
    { path: '/home',           element: HomePage,      private: true },
    { path: '/secured',        element: SecuredPage,   private: true, roles: ['ADMIN'] },
    { path: '/clientes',       element: ClientsPage,   private: true },
    { path: '/dispositivos',             element: Dispositivos,           private: true },
    { path: '/dispositivos/:clientId',   element: DispositivosClientView, private: true },
    { path: '/sensores',       element: SensoresEModelos, private: true },
    { path: '/usuarios',       element: UsuarioPage,   private: true, roles: ['ADMIN'] },
    { path: '/protocolos',     element: Protocolos,    private: true, roles: ['ADMIN'] },
    { path: '/definicoes',     element: Definicoes,    private: true, roles: ['ADMIN'] },
    { path: '/analise-microbiologica', element: Microbio, private: true },
    { path: '/firmwares',      element: FirmwarePage,  private: true, roles: ['ADMIN'] },
    { path: '/frota',          element: FrotaPage,     private: true, roles: ['ADMIN'] },
    { path: '/frota/:serial',  element: TorrePage,     private: true, roles: ['ADMIN'] },
    { path: '/alertas',        element: AlertasPage,   private: true, roles: ['ADMIN'] },
    { path: '/sensor-cor',     element: SensorCorPage, private: true, roles: ['ADMIN'] },
    { path: '/certificados',   element: CertificadosPage, private: true },

    // Admin
    { path: '/admin/licenciamentos', element: LicenciamentoAdminPage, private: true, roles: ['ADMIN'] },

    // Gestor
    { path: '/licenciamentos', element: LicenciamentoGestorPage, private: true, roles: ['GESTOR'] },
    { path: '/recursos',       element: Recursos,     private: true, roles: ['GESTOR'] },
    { path: '/external',       element: PageExternal, private: true, roles: ['GESTOR'] },

    // NotFound
    { path: '*',               element: NotFound,      private: false },
];
